// same types defined in analytics-web-client but avoid creating dependency with that

export const UI_EVENT_TYPE = 'ui';
export const TRACK_EVENT_TYPE = 'track';
export const SCREEN_EVENT_TYPE = 'screen';
export const OPERATIONAL_EVENT_TYPE = 'operational';
export const DEFAULT_SOURCE = 'unknown';